import { Component, OnInit, OnDestroy } from '@angular/core';
import { HomeModel } from './home.model';
import { Store } from '@ngrx/store';

import { State } from '../../reducers/index';
import { HIDE_HEADER } from '../../actions/header.action';
import { INFO_UPDATE } from '../../actions/info.action';
import { Booking, BOOKING_REQUEST } from '../../actions/booking.action';

@Component({
  selector: 'consentz-home-component',
  templateUrl: './home.template.html',
  styleUrls: ['./home.styles.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public model: HomeModel = new HomeModel(JSON.parse(localStorage.getItem('currentBookingOptions')), window.location.hash.split('/')[1]);
  public subscribtion$: any;
  public clinicLogo = 'https://consentz-london.s3.eu-west-2.amazonaws.com/live-server/app-logo.jpg';

  constructor(
    private store: Store<State>
  ) {
    // show header, allow ovelay, subscribtion on widget options
    this.store.dispatch({ type: HIDE_HEADER });
    this.store.dispatch({ type: BOOKING_REQUEST });
    this.subscribtion$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
      if (Object.keys(data).find(key => key === 'logo')) {
        this.clinicLogo = data.logo;
      }
    });
  }

  public ngOnInit(): void {
    localStorage.removeItem('data');
    localStorage.removeItem('day');
    localStorage.removeItem('clinicId');
    localStorage.removeItem('practitionerId');
    localStorage.removeItem('Appointment');
    localStorage.removeItem('treatmentId');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserToken');
    localStorage.removeItem('RegistrationUserPassword');
    localStorage.removeItem('RegistrationUserEmail');
    localStorage.removeItem('treatmentTime');
    localStorage.setItem('AppId', window.location.hash.split('/')[1]);
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: {
        clinic: null,
        treatment: null,
        price: null,
        practitioner: null,
        date: null,
        dateBusy: null,
        customer: null,
        token: null,
        data: null,
        time: null,
        type: null,
        details: null
      }
    });
  }

  // unsubscribe from store
  public ngOnDestroy(): void {
    this.subscribtion$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/home/home.component.ts